/**
 * Base URL for all API calls.
 * 
 * Centralizes the server URL so it only needs to be changed in one place.
 * Used by both axios.jsx (for regular HTTP requests) and sseClient.js (for SSE streaming).
 */

let BASE_URL = 'https://userver-22gy.onrender.com'

if (import.meta.env.VITE_LOCAL_MODE) {
    BASE_URL = 'http://localhost:8000'
}

export default BASE_URL
